import { CompetenciaInput, DateInput, TextInput } from '@core/components/Inputs';
import CodigoBarrasInput from '@core/components/Inputs/CodigoBarrasInput';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectConta from 'app/components/Select/SelectConta';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import React from 'react';
import ContasPagarAproveitamentoCredito from './ContasPagarAproveitamentoCredito';
import ContasPagarCategorias from './ContasPagarCategorias';
import FormaDePagamento from './FormaDePagamento';
import SwitchFavorecidoFornecedor from './SwitchFavorecidoFornecedor';

const APROVEITAMENTO_CREDITO_DEFAULT = {
  valorCreditoIbs: null,
  valorCreditoCbs: null,
  tipoAproveitamentoCredito: 'NAO_APROVEITA_CREDITO',
  aliquotaIbs: null,
  aliquotaCbs: null,
  percentualCredito: null,
  observacaoJustificativa: '',
  ativo: true,
};

const DespesaDetalhesCodigoBarras = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  origemConciliacao,
  empresaIbsCbs,
}) => {
  const checked = values.favorecidoDiferenteFornecedor;

  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com situação "Baixada", somente a aba “Anexar documento” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição.
  */
  const contaBaixada = values?.situacao === 'BAIXADA' || values?.situacao === 'PARCIAL';

  const dataVencimento = !values?.dataVencimento?._isValid ? null : values.dataVencimento;

  return (
    <>
      <Grid item xs={12} sm={8}>
        <SelectFornecedor
          autoFocus
          handleChange={handleChange}
          handleBlur={handleBlur}
          fornecedor={values?.fornecedor}
          touched={touched?.fornecedor}
          error={errors?.fornecedor}
          disabled={contaBaixada}
          required
        />
      </Grid>
      <SwitchFavorecidoFornecedor
        checked={checked}
        handleChange={handleChange}
        handleBlur={handleBlur}
        disabled={contaBaixada}
      />

      {checked && (
        /*
        RNE-137 - Exibição do campo "Favorecido" : Public <<Functional>> Feature
        O sistema deve exibir, inicialmente, somente o campo "Fornecedor" no lançamento da despesa. Caso o usuário marque o campo "Favorecido diferente do fornecedor", o sistema exibe o campo "Favorecido". Nesse caso, o "Favorecido" torna-se obrigatório.

        Observação: O sistema deve possibilitar a pesquisa de favorecidos nos fornecedores cadastrados.
        */
        <Grid item xs={12}>
          <SelectFornecedor
            required
            id="favorecido.id"
            label="Favorecido"
            idObject="favorecido"
            handleChange={handleChange}
            handleBlur={handleBlur}
            fornecedor={values?.favorecido}
            touched={touched?.favorecido}
            error={errors?.favorecido}
            disabled={contaBaixada}
          />
        </Grid>
      )}

      <Grid item xs={12} sm={4}>
        <CompetenciaInput
          fullWidth
          required
          id="competencia"
          label="Mês Competência"
          value={values?.competencia}
          onChange={handleChange}
          touched={touched?.competencia}
          error={errors?.competencia}
          helperText={errors?.competencia}
          disabled={contaBaixada}
          format="MM/YYYY"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateInput
          fullWidth
          required
          id="dataVencimento"
          label="Data do vencimento"
          value={dataVencimento}
          onChange={handleChange}
          disabled={contaBaixada}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputMonetario
          fullWidth
          id="valorTotal"
          label="Valor total (R$)"
          onBlur={handleBlur}
          value={values?.valorTotal}
          error={errors?.valorTotal && touched?.valorTotal}
          helperText={errors?.valorTotal}
          handleChange={handleChange}
          disabled={contaBaixada}
          required
        />
      </Grid>

      <ContasPagarCategorias
        handleChange={handleChange}
        handleBlur={handleBlur}
        values={values}
        errors={errors?.categorias}
        touched={touched?.categorias}
        disabled={contaBaixada}
        disabledDescricao={contaBaixada}
        origemConciliacao={origemConciliacao}
      />

      <Grid item xs={12} sm={6}>
        <SelectConta
          id="conta"
          fullWidth
          label="Conta"
          value={values?.conta}
          onChange={(event) => {
            handleChange(event);
            handleChange({ target: { id: 'formaPagamento', value: undefined } });
          }}
          onBlur={handleBlur}
          disabled={contaBaixada}
          touched={errors.conta}
          error={errors.conta}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormaDePagamento
          label="Forma do pagamento"
          value={values?.formaPagamento}
          handleChange={handleChange}
          onBlur={handleBlur}
          maxLength={100}
          tipoConta={values?.conta?.tipo}
          disabled={contaBaixada}
          touched={errors?.formaPagamento}
          error={errors?.formaPagamento}
          required={errors?.formaPagamento}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput
          id="documentoFiscal"
          fullWidth
          label="Documento fiscal"
          value={values?.documentoFiscal}
          onChange={handleChange}
          onBlur={handleBlur}
          maxLength={30}
          disabled={contaBaixada}
          // touched={emailTouched}
          // error={emailError}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateInput
          fullWidth
          disableFuture
          id="dataEmissao"
          label="Data da emissão"
          value={values?.dataEmissao}
          onChange={handleChange}
          disabled={contaBaixada}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="observacao"
          name="observacao"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.observacao}
          error={errors.observacao}
          touched={touched.observacao}
          disabled={contaBaixada}
          fullWidth
          maxLength={500}
          multiline
          rows={3}
          variant="outlined"
          label="Observação"
        />
      </Grid>
      {empresaIbsCbs && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              label="Aproveitamento de crédito IBS/CBS"
              control={
                <Switch
                  id="aproveitamentoCreditoAtivo"
                  name="aproveitamentoCreditoAtivo"
                  value={values?.aproveitamentoCreditoAtivo}
                  checked={values?.aproveitamentoCreditoAtivo}
                  color="primary"
                  onChange={(event) => {
                    if (event.target.checked) {
                      handleChange({
                        target: {
                          id: 'aproveitamentoCredito',
                          value: APROVEITAMENTO_CREDITO_DEFAULT,
                        },
                      });
                    } else {
                      handleChange({ target: { id: 'aproveitamentoCredito', value: null } });
                    }
                    handleChange(event);
                  }}
                  onBlur={handleBlur}
                  disabled={contaBaixada}
                />
              }
            />
          </Grid>
          {values?.aproveitamentoCreditoAtivo && (
            <>
              <ContasPagarAproveitamentoCredito
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                aproveitamentoCreditoFlag={values?.aproveitamentoCreditoAtivo}
                disabled={contaBaixada}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

const ContasPagarCodigoBarras = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  origemConciliacao,
  empresaIbsCbs = false,
}) => {
  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com situação "Baixada", somente a aba “Anexar documento” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição.
  */
  const contaBaixada = values?.situacao === 'BAIXADA' || values?.situacao === 'PARCIAL';

  return (
    <>
      <Grid item xs={12}>
        <CodigoBarrasInput
          autoFocus
          id="linhaDigitavel"
          name="linhaDigitavel"
          onChange={(event, { valor, vencimento, sucesso }) => {
            if (sucesso) {
              handleChange(event);
              handleChange({ target: { id: 'valorTotal', value: valor } });
              handleChange({ target: { id: 'dataVencimento', value: vencimento } });
            } else {
              handleChange(event);
              handleChange({ target: { id: 'valorTotal', value: undefined } });
              handleChange({ target: { id: 'dataVencimento', value: undefined } });
            }
          }}
          onBlur={handleBlur}
          value={values?.linhaDigitavel}
          error={errors.linhaDigitavel}
          helperText={errors.linhaDigitavel}
          touched={touched.linhaDigitavel}
          disabled={contaBaixada}
          required
          fullWidth
          variant="outlined"
          label="Código de barras"
        />
      </Grid>

      {values?.valorTotal && values?.dataVencimento && values?.linhaDigitavel && (
        <DespesaDetalhesCodigoBarras
          handleChange={handleChange}
          handleBlur={handleBlur}
          values={values}
          errors={errors}
          touched={touched}
          origemConciliacao={origemConciliacao}
          empresaIbsCbs={empresaIbsCbs}
        />
      )}
    </>
  );
};

export default ContasPagarCodigoBarras;
